import orderBadge from "./index.vue";
export default orderBadge;
